import { AppDefinedVariables, Data } from "../textInterfaces";

import { replaceNumStringVariables } from "Components/TextContext";

export const getComponentTextByFieldId = (
  components: Data[],
  fieldId: string,
  appDefinedVariables?: AppDefinedVariables,
): string | undefined => {
  const foundComponent = components.find(
    (component) => component.name.split(".")[2] === fieldId.toLowerCase(),
  );

  if (foundComponent === undefined) {
    return undefined;
  }

  return foundComponent.variables !== undefined
    ? replaceNumStringVariables(foundComponent, appDefinedVariables)
    : foundComponent.text;
};
